import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('NewsTranslation')
export class NewsTranslation {

  @JsonProperty('title', String)
  title: string = '';

  @JsonProperty('summary', String)
  summary: string = '';

  @JsonProperty('content', String)
  content: string = '';

  @JsonProperty('link_button_name', String)
  linkButtonName: string = '';

  @JsonProperty('language_id', Number)
  languageId: number = 0;
}
